import { useTranslation } from 'react-i18next'

export default (translation) => {
  const { t } = useTranslation()
  return t(translation)
}